import React, { useState } from 'react'
import { ProductFeature } from '@/pages/products/components/features/ProductFeature'
import { Fields } from '@hako/core'

export const ProductFeaturesList = ({ items }) => {
    const [isAllVisible, setIsAllVisible] = useState(false)

    return (
        <>
            <ProductFeature
                isGray={false}
                title={items[0].title}
                description={items[0].description}
                imageURL={items[0].image}
            />

            {isAllVisible &&
                items.map((feature, index) => (
                    <ProductFeature
                        key={index}
                        isFirst={index === 0}
                        isGray={(index + 1) % 2 === 0}
                        title={feature.title}
                        description={feature.description}
                        imageURL={feature.image}
                    />
                ))}

            <section
                className={`section ${
                    items.length % 2 === 0 && isAllVisible
                        ? 'section--gray'
                        : ''
                } u-padding-top-none`}
            >
                <div className="table__btn u-flex-row u-justify-content-center">
                    <button
                        className="btn btn--secondary btn--dark"
                        onClick={() =>
                            setIsAllVisible((prevState) => !prevState)
                        }
                    >
                        {isAllVisible ? (
                            <Fields.Text
                                editable={false}
                                key={isAllVisible}
                                as="span"
                                scope="global"
                                slug="show-less-list"
                            >
                                Show less
                            </Fields.Text>
                        ) : (
                            <Fields.Text
                                editable={false}
                                key={isAllVisible}
                                as="span"
                                scope="global"
                                slug="see-full-features"
                            >
                                See all product features
                            </Fields.Text>
                        )}
                    </button>
                </div>
            </section>
        </>
    )
}
